<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="reset"
    @keydown="form.onKeydown($event)"
  >
      <toolbar
        :title="title"
        :loading="form.busy"
        enctype="multipart/form-data"
        :buttons="buttons"
        @save="save"
        @cancel="cancel"
      />
      <v-layout
        :id="ref"
        class="wrap justify-space-around form-body"
      >
          <v-col cols="12" md="12">
            <v-autocomplete
              v-model="form.id_template"
              :rules="[rules.required]"
              :items="templatesList"
              :filter="customFilter"
              item-value="id"
              item-text="name"
              label="Plantillas"
            >
              <template v-slot:selection="data">
                {{ data.item.name }} - {{ data.item.version }}
              </template>
              <template v-slot:item="data">
                {{ data.item.name }} - {{ data.item.version }}
              </template>
            </v-autocomplete>
          </v-col>
      </v-layout>
  </v-form>
</template>

<script>
import Form from 'vform';
import Toolbar from '~/components/Toolbar';

export default {
  middleware: 'auth',
  components: {
    Toolbar,
  },
  props: {
    enterpriseId: { default: '' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      form: new Form({
        id_template: '',
        active: '1',
        doc_type: '00',
        template: 'Correo',
        type: 'FEL',
        busy: false,
      }),
      items: [
        { value: '00', text: 'Todos los Documentos' },
      ],
      templatesList: [],
      name: '',
      title: 'Asociación de Personalización de Correo',
      dialog: false,
      file: '',
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      buttons: [
        {
          id: 'save',
          icon: 'mdi-content-save',
          name: 'Guardar',
          event: 'save',
          color: 'success',
        },
        {
          id: 'cancel',
          icon: 'mdi-close',
          name: 'Volver',
          event: 'cancel',
        },
      ],
      apiURL: '/api/enterprises',
      apiURLTemplate: 'templates-subject/store',
      method: 'POST',
  }),
  computed: {
    ref() { return this.form.id; },
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
  },
  async mounted() {
    await this.showTemplates();
  },
  methods: {
      customFilter(item, queryText) {
        const textOne = (item.name !== null) ? item.name.toLowerCase() : '';
        const textTwo = (item.version !== null) ? item.version.toLowerCase() : '';
        const searchText = queryText.toLowerCase();

        return textOne.indexOf(searchText) > -1
          || textTwo.indexOf(searchText) > -1;
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        const formData = new FormData();
        formData.append('file', this.file);
        formData.append('id_template', this.form.id_template);
        formData.append('template', this.form.template);
        formData.append('doc_type', this.form.doc_type);
        const URL = `${this.apiURL}/${this.enterpriseId}/${this.apiURLTemplate}`;
        window.axios.post(URL, formData)
        .then(() => {
          this.form.busy = false;
          this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      showTemplates() {
        window.axios.get('/api/catalogs/templates-subject/getAllTemplatesSubject')
        .then((result) => {
          this.showAdd = !this.showAdd;
          this.templatesList = result.data.items;
        });
      },
    },
};
</script>
